import { render, staticRenderFns } from "./PxSelectSimple.vue?vue&type=template&id=1e18b0e4"
import script from "./PxSelectSimple.vue?vue&type=script&lang=js"
export * from "./PxSelectSimple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports